var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShape18(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L18 0L18 18L0 18L0 0Z",
    id: "path_1"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "mask_1"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path_1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "alfiler"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L18 0L18 18L0 18L0 0Z",
    id: "Background",
    fill: "#FFFFFF",
    fillOpacity: 0,
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#mask_1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Pin",
    transform: "translate(2.25 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.75 0C3.02413 0.00494277 0.00494224 3.02413 0 6.75C0 11.5959 6.28875 17.6653 6.55594 17.9212C6.664 18.0263 6.836 18.0263 6.94406 17.9212C7.21125 17.6653 13.5 11.5959 13.5 6.75C13.495 3.02405 10.4758 0.00490308 6.74993 0L6.75 0ZM6.75 9.84375C5.04137 9.84375 3.65625 8.45863 3.65625 6.75C3.65625 5.04138 5.04136 3.65626 6.74999 3.65625C8.45862 3.65624 9.84374 5.04136 9.84375 6.74998C9.84273 8.45821 8.4582 9.84273 6.74999 9.84375L6.75 9.84375Z",
    id: "Shape",
    fill: "#404040",
    fillRule: "evenodd",
    stroke: "none"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShape18);
export default __webpack_public_path__ + "static/media/shape18.d748c8633a048fc2e6fe4cd8eda9ad7f.svg";
export { ForwardRef as ReactComponent };